import React, {Component} from 'react'
import './App.css';
import Loader from './cmp/Loader'
import AuthForm from './cmp/authForm'
import MenuBar from './cmp/MenuBar'
import TabPanel from './cmp/TabPanel'
//import Header from './cmp/header'
import MsgForm from './cmp/msgForm'
import WndForm from './cmp/WndForm'
import RangeForm from './cmp/RangeForm'
import NumberForm from './cmp/NumberForm'
import WeightForm from './cmp/WeightForm'
import LongTextForm from './cmp/LongTextForm'
import ExciseForm from './cmp/ExciseForm'
import TextForm from './cmp/TextForm'
import ColsForm from './cmp/ColsForm'
import ArrayForm from './cmp/arrayForm'

import CatGoodsList from './hoc/CatGoodsList'
import CatGoodsEdit from './hoc/CatGoodsEdit'
import FldGoodsEdit from './hoc/FldGoodsEdit'
import CatMenuGrpList from './hoc/CatMenuGrpList'
import CatMenuGrpEdit from './hoc/CatMenuGrpEdit'
import FldMenuGrpEdit from './hoc/FldMenuGrpEdit'
import CatUsersList from './hoc/CatUsersList'
import CatUsersEdit from './hoc/CatUsersEdit'
import CatDepartmentsList from './hoc/CatDepartmentsList'
import CatDevicesList from './hoc/CatDevicesList'
import CatDevices3Edit from './hoc/CatDevices3Edit'
import CatDevices4Edit from './hoc/CatDevices4Edit'
import CatDevices4Viev from './hoc/CatDevices4Viev'
import CatDevices5Edit from './hoc/CatDevices5Edit'
import CatDevices5Viev from './hoc/CatDevices5Viev'
import CatDiscountsList from './hoc/CatDiscountsList'
import CatDiscountsEdit from './hoc/CatDiscountsEdit'
import FldDiscountsEdit from './hoc/FldDiscountsEdit'
import CatHallsList from './hoc/CatHallsList'
import CatHallsEdit from './hoc/CatHallsEdit'
import CatTablesList from './hoc/CatTablesList'
import CatCounterpartiesList from './hoc/CatCounterpartiesList'
import CatCounterpartiesEdit from './hoc/CatCounterpartiesEdit'
import FldCounterpartiesEdit from './hoc/FldCounterpartiesEdit'
import CatArticlesList from './hoc/CatArticlesList'
import CatCashAccsList from './hoc/CatCashAccsList'
import CatReasonsList from './hoc/CatReasonsList'
import CatReasonsEdit from './hoc/CatReasonsEdit'
import CatTextsList from './hoc/CatTextsList'
import CatCertificatesList from './hoc/CatCertificatesList'
import CatCertificatesEdit from './hoc/CatCertificatesEdit'
import CatPositionsList from './hoc/CatPositionsList'
import CatPositionsEdit from './hoc/CatPositionsEdit'
import CatEmployeesList from './hoc/CatEmployeesList'
import CatEmployeesEdit from './hoc/CatEmployeesEdit'
import CatStreetsList from './hoc/CatStreetsList'
import CatCitiesList from './hoc/CatCitiesList'
import CatAreasList from './hoc/CatAreasList'

import DocOrderList from './hoc/DocOrderList'
import DocOrderEdit from './hoc/DocOrderEdit'
import DocSupplyList from './hoc/DocSupplyList'
import DocSupplyEdit from './hoc/DocSupplyEdit'
import DocRejectList from './hoc/DocRejectList'
import DocRejectEdit from './hoc/DocRejectEdit'
import DocTransferList from './hoc/DocTransferList'
import DocTransferEdit from './hoc/DocTransferEdit'
import DocExpenceList from './hoc/DocExpenceList'
import DocExpenceEdit from './hoc/DocExpenceEdit'
import DocSurplusList from './hoc/DocSurplusList'
import DocSurplusEdit from './hoc/DocSurplusEdit'
import DocCalculationList from './hoc/DocCalculationList'
import DocCalculationEdit from './hoc/DocCalculationEdit'
import DocProductionList from './hoc/DocProductionList'
import DocProductionEdit from './hoc/DocProductionEdit'
import DocRevisionList from './hoc/DocRevisionList'
import DocRevisionEdit from './hoc/DocRevisionEdit'
import DocStatementList from './hoc/DocStatementList'
import DocStatementEdit from './hoc/DocStatementEdit'
import DocCashadjustList from './hoc/DocCashadjustList'
import DocCashadjustEdit from './hoc/DocCashadjustEdit'
import DocDebtadjustList from './hoc/DocDebtadjustList'
import DocDebtadjustEdit from './hoc/DocDebtadjustEdit'
import DocBonusadjustList from './hoc/DocBonusadjustList'
import DocBonusadjustEdit from './hoc/DocBonusadjustEdit'
import DocRefillCertList from './hoc/DocRefillCertList'
import DocRefillCertEdit from './hoc/DocRefillCertEdit'
import DocNullifyCertList from './hoc/DocNullifyCertList'
import DocNullifyCertEdit from './hoc/DocNullifyCertEdit'
import DocSalaryList from './hoc/DocSalaryList'
import DocSalaryEdit from './hoc/DocSalaryEdit'
import DocPaymentList from './hoc/DocPaymentList'
import DocPaymentEdit from './hoc/DocPaymentEdit'
import DocConversionList from './hoc/DocConversionList'
import DocConversionEdit from './hoc/DocConversionEdit'

import IrgStopList from './hoc/IrgStopList'
import IrgTimekeepingList from './hoc/IrgTimekeepingList'

import DocPrint from './hoc/DocPrint'

import RepSupplies from './hoc/RepSupplies'
import RepLiability from './hoc/RepLiability'
import RepDebt from './hoc/RepDebt'
import RepCalcs from './hoc/RepCalcs'
import RepProduction from './hoc/RepProduction'
import RepStock from './hoc/RepStock'
import RepSales from './hoc/RepSales'
import RepReturn from './hoc/RepReturn'
import RepStats from './hoc/RepStats'
import RepForm496 from './hoc/RepForm496'
import RepCashflow from './hoc/RepCashflow'
import RepPnL from './hoc/RepPnL'
import RepDelivery from './hoc/RepDelivery'
import RepConversion from './hoc/RepConversion'
import RepObjHistory from './hoc/RepObjHistory'
import RepObjEntries from './hoc/RepObjEntries'
import RepSysLog from './hoc/RepSysLog'

import SysConstList from './hoc/SysConstList'
import ServCheck from './hoc/ServCheck'
import ServGrpEdit from './hoc/ServGrpEdit'
import ServGrpDoc from './hoc/ServGrpDoc'
import ServQRDesign from './hoc/servQRDesign'
import AISupplyFill from './hoc/AISupplyFill'

import {load,loadfrm,loaddat,localestr,dataContext,toText,itemToText,typeToText,allTypes,get_object_types} from './utils.js'
import {MenuData} from './menudata'
import RepSysBASE from './hoc/RepBAS.js';

let allSettings={}
let positions={}
let ws
let busy=false
let wndDataGl=[]  //Для зберігання даних відкритих вкладок, тих що не в стейті (щоб не перемальовувалось)
let wndTDataGl=[]  //Для зберігання даних у модальних вікнах
class App extends Component {
  state = {
    status:'',
    user_id:'',
    user:'',
    menu:MenuData,
    hidenmenu:false,
    windows:[],
    wnd:[],
    activeWindow:0,
    lastWindow:0,
    modal:'',
    modal2:'',
    data:{
      selYN:[{name:localestr('Так'),value:'1'},{name:localestr('Ні'),value:'0'}],
      selYNttl:[{name:localestr('Так'),value:'2'},{name:localestr('Ні'),value:'0'},{name:localestr('Крім підакцизних'),value:'1'}],
      selYNQ:[{name:localestr('Так'),value:'1'},{name:localestr('Ні'),value:'0'},{name:localestr('Запитувати'),value:'2'}],
      selGoodType:[{name:localestr('З акцизними марками'),value:'0'},{name:localestr('Товар'),value:'1'},{name:localestr('Продукція'),value:'2'},{name:localestr('Напівфабрикат'),value:'3'},{name:localestr('Послуга'),value:'4'}],
      selGoodType2:[{name:localestr('Товар'),value:'1'},{name:localestr('Продукція'),value:'2'},{name:localestr('Напівфабрикат'),value:'3'}],
      selUnitType:[{name:localestr('шт'),value:'1'},{name:localestr('г'),value:'10'},{name:localestr('кг'),value:'2'},{name:localestr('л'),value:'3'},{name:localestr('пач'),value:'4'},{name:localestr('пляш'),value:'9'},{name:localestr('м'),value:'5'},{name:localestr('грн'),value:'6'},{name:localestr('год'),value:'7'},{name:localestr('пор'),value:'8'},{name:localestr('100г'),value:'11'}],
      selDeviceType:[{name:localestr('Принтер PrintFromSite'),value:'1'},{name:localestr('Принтер RawBT'),value:'2'},{name:localestr('Екранний принтер'),value:'3'},{name:localestr('Фіскальний реєстратор'),value:'4'},{name:localestr('Тестовий реєстратор'),value:'5'},{name:localestr('Банківський термінал'),value:'7'}],
      selDiscountType:[{name:localestr('Звичайний процент'),value:'0'},{name:localestr('Накопичувальні бонуси'),value:'1'},{name:localestr('Фіксована сума в місяць'),value:'2'}],
      selOrderTypes:[{name:localestr('У закладі'),value:'0'},{name:localestr('Доставка'),value:'1'},{name:localestr('Самовивіз'),value:'2'},{name:localestr('Бенкет'),value:'3'}],
      selPayTypes:[{name:localestr('Готівкою'),value:'0'},{name:localestr('Карткою'),value:'1'},{name:localestr('Liqpay'),value:'2'},{name:localestr('QR код моно'),value:'3'},{name:localestr('Сертифікат'),value:'4'},{name:localestr('Комбінований платіж'),value:'5'},{name:localestr('По перерахунку'),value:'6'}],
      selPayTypes2:[{name:localestr('Готівкою'),value:'0'},{name:localestr('Готівкою в закладі'),value:'10'},{name:localestr('Карткою'),value:'1'},{name:localestr('Карткою в закладі'),value:'11'},{name:localestr('Liqpay'),value:'2'},{name:localestr('QR код моно'),value:'3'},{name:localestr('Сертифікат'),value:'4'},{name:localestr('Комбінований платіж'),value:'5'},{name:localestr('По перерахунку'),value:'6'}],
      selFiscalTypes:[{name:localestr('Авто (визначені позиції)'),value:'0'},{name:localestr('Фіскально всі позиції'),value:'1'},{name:localestr('Не фіскально всі позиції'),value:'2'},{name:localestr('За вибором користувача'),value:'3'}],
      selFiscalTypes2:[{name:localestr('Авто'),value:'0'},{name:localestr('Фіскально'),value:'1'},{name:localestr('Не фіскально'),value:'2'}],
      selFiscalMarks:[{name:localestr('За вибором користувача'),value:'0'},{name:localestr('При відкритті пляшки'),value:'1'},{name:localestr('В кожній продажі'),value:'2'},{name:localestr('Без запиту марки'),value:'3'}],
      selExcise:[{name:localestr('Без акцизу'),value:'0'},{name:localestr('Д-Лікеро-горілчана продукція'),value:'1'},{name:localestr('Е-Виноробна продукція'),value:'2'},{name:localestr('Ж-Пиво'),value:'3'},{name:localestr('З-напої без акцизу'),value:'4'},{name:localestr('К-Тютюнові без акцизу'),value:'-1'}],
      selOrderStatus:[{name:localestr('Прийнято'),value:'1'},{name:localestr('Готується'),value:'2'},{name:localestr('На видачі'),value:'3'},{name:localestr('Скасовано'),value:'4'},{name:localestr('До оплати'),value:'5'}],
      radCheckType:[{name:localestr('Продаж'),value:'0'},{name:localestr('Повернення'),value:'1'}],
      selSelectionType:[{name:localestr('Без запитань'),value:'0'},{name:localestr('Запитувати кількість'),value:'1'},{name:localestr('Запитувати кількість і ціну'),value:'2'},{name:localestr('Запитувати кількість і суму'),value:'3'}],
      selStatementOper:[{name:localestr('Оплата постачальнику'),value:'1'},{name:localestr('Поступлення від постачальника'),value:'2'},{name:localestr('Передача до каси/на рахунок'),value:'3'},{name:localestr('Поступлення від покупця'),value:'4'},{name:localestr('Виплата зарплати'),value:'5'},{name:localestr('Виплата засновнику(власнику)'),value:'7'},{name:localestr('Інші видатки'),value:'8'},{name:localestr('Інші поступлення'),value:'9'},{name:localestr('Сплата ЭСВ'),value:'10'},{name:localestr('Сплата ПДФО'),value:'11'},{name:localestr('Сплата військового збору'),value:'12'}],
      selAllTypes:get_object_types(),
      selDocOper:[{name:localestr('Провести / Перепровести'),value:1},{name:localestr('Зробити не проведеним'),value:2},{name:localestr('Позначити на видалення'),value:3},{name:localestr('Зняти позначку видалення'),value:4}],
      selDocType:[{name:localestr('В закладі'),value:'0'},{name:localestr('Доставка'),value:'1'},{name:localestr('Самовивіз'),value:'2'}],
      selOnlinePay:[{name:localestr('одразу після замовлення'),value:'1'},{name:localestr('після підтвердження персоналом'),value:'0'}],
      selStyleQR:[{name:localestr('Класичний'),value:0},{name:localestr('Стильний'),value:1},{name:localestr('Розплавлений'),value:2},{name:localestr('Мінімалістичний'),value:3},{name:localestr('Діловий'),value:4}],
      selPayKinds:[{name:localestr('Аванс'),value:'0'},{name:localestr('Зарплата'),value:'1'}],
      selConversionType:[{name:localestr('Розбирання'),value:'0'},{name:localestr('Компонування'),value:'1'}],
      selTerminalCon:[{name:localestr('Не підключено'),value:'0'},{name:localestr('Приват Банк'),value:'PBTerminal'},{name:localestr('Ingenico'),value:'ECRCommX'},{name:localestr('SmartOne'),value:'SmartOne'}],
      selOperations:[{name:localestr('Вхід/Вихід'),value:'log'},{name:localestr('Створення'),value:'add'},{name:localestr('Зміна даних'),value:'mod'},{name:localestr('Позначка на знищення'),value:'rem'},
        {name:localestr('Позначка на знищення'),value:'rm1'},{name:localestr('Відміна позначки'),value:'rm0'},{name:localestr('Зміна періодичних даних'),value:'set'},{name:localestr('Видалення періодичних даних'),value:'del'},
        {name:localestr('Зміна періодичних даних'),value:'rgo'},{name:localestr('Проведення'),value:'pst'},{name:localestr('Відміна проведення'),value:'ups'},{name:localestr('Остаточне видалення'),value:'clr'},{name:localestr('Друк замовлення'),value:'pr1'},
        {name:localestr('Друк рахунку'),value:'pr2'},{name:localestr('Друк чека'),value:'pr3'},{name:localestr('Розділення чека'),value:'brk'}]
    }
  }

  showHideMenu=()=>{
    const hidenmenu=!this.state.hidenmenu
    this.setState({hidenmenu})
  }

  tabClick=(idx)=>{
    const lastWindow=this.state.activeWindow
    this.setState({activeWindow:idx,lastWindow})
  }

  tabClose=(idx,activetab,q=true)=>{

    if(q&&this.state.windows[idx].need_save){
      this.msg(localestr("Дані не збережено! \nЗакрити без збереження?"),localestr('Збереження даних'),[{caption:'OK',action:()=>this.tabClose(idx,activetab,false)},{caption:localestr('Відмінити'),action:()=>{}}])
      return
    }
    
    let active = activetab
    let lastWindow = this.state.lastWindow
    if (idx<lastWindow) lastWindow-=1
    if(idx===active) active=lastWindow
    else if (idx<active) active-=1
    if (this.state.windows.length>0) active=Math.max(0,active)
    const windows=this.state.windows.filter((item,index)=>{return index!==idx})
    wndDataGl=wndDataGl.filter((item,index)=>{return index!==idx})
    if(active>=windows.length) active=Math.max(0,windows.length-1)
    const activeWindow=active
    this.setState({windows, activeWindow})
  }

  setUpdate=(idx,status)=>{
    const windows=[...this.state.windows]
    windows[idx].need_save=status
    this.setState({windows})
  }

  tabNew=(wndType,caption,dataItem='',multytab=false)=>{
    const lastWindow=this.state.activeWindow
    if(!this.state.urAdmin&&wndType.substr(-4)==='edit'){
      let wndType1=wndType.substr(0,wndType.length-4)+'list'
      if(!this.state.rights[wndType1]) return null
    }
    
    //визначити тип компонента
    //Перевірити чи є вже такі дані
    if(!multytab){
      const idx=this.state.windows.findIndex(el=>el.caption===caption&&el.wndType===wndType)
      if(idx!==-1){
        const activeWindow=idx
        this.setState({activeWindow,lastWindow})
        return
      }
    }
    //Якщо нема підгрузити
    //передати компоненту дані і помістити у масив вікон
    let data=dataItem
  //if (wndType==='catUsers')
    const windows=this.state.windows.concat({caption,wndType,data})
    wndDataGl.push({})
    const activeWindow=windows.length-1
    this.setState({windows, activeWindow,lastWindow})
  }

  setModal=(modal)=>{
    this.setState({modal})
  }
  
  setModal2=(modal2)=>{
    this.setState({modal2})
  }

  msg=(str,capt,act)=>{
    if(this.state.modal){
      const modal2=<MsgForm Text={str} caption={capt} setModal={this.setModal2} actions={act} id={'2'} />
      this.setState({modal2})
    } else {
      const modal=<MsgForm Text={str} caption={capt} setModal={this.setModal} actions={act} />
      this.setState({modal})
    }
  }

  close_msg=()=>{
    if(this.state.modal2){
      this.setState({modal2:null})
    } else {
      this.setState({modal:null})
    }
  }

  msg_arr=(str,capt,act)=>{
    if(this.state.modal){
      const modal2=<ArrayForm Text={str} caption={capt} setModal={this.setModal2} actions={act} id={'2'} />
      this.setState({modal2})
    } else {
      const modal=<ArrayForm Text={str} caption={capt} setModal={this.setModal} actions={act} />
      this.setState({modal})
    }
  }

  msg2=(str,capt,act)=>{
    const modal2=<MsgForm Text={str} caption={capt} setModal={this.setModal2} actions={act} id={'2'} />
    this.setState({modal2})
  }

  inputRange=(from,to,act)=>{
    const modal=<RangeForm from={from} to={to} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  inputNumber=(capt1,capt2,number,act)=>{
    const modal=<NumberForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  inputWeight=(capt1,capt2,number,act)=>{
    const modal=<WeightForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  inputWeight2=(capt1,capt2,number,act)=>{
    const modal=<WeightForm capt1={capt1} capt2={capt2} number={number} setModal={this.setModal} action={act} disable={true} />
    this.setState({modal})
  }

  inputLongText=(capt,val,act)=>{
    const modal=<LongTextForm capt={capt} value={val} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  inputExcise=(capt,val,act,is_liter)=>{
    const modal=<ExciseForm capt={capt} value={val} setModal={this.setModal} action={act} is_liter={is_liter}/>
    this.setState({modal})
  }

  inputText=(capt,val,act)=>{
    const modal=<TextForm capt={capt} value={val} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  inputCols=(cols,act)=>{
    const modal=<ColsForm capt={localestr('Налаштування таблиці')} data={cols} setModal={this.setModal} action={act} />
    this.setState({modal})
  }

  isActive=(idx)=>{
    if(idx===this.state.activeWindow){
      if(this.state.wnd.length) return false
      if(this.state.modal) return false
      if(this.state.modal2) return false
      return true
    }
    return false
  }

  isActiveT=(idx)=>{
    if(this.state.wnd.length-1===idx) return true
    return false
  }

  setTUpdate=(idx,status)=>{
    const wnd=[...this.state.wnd]
    wnd[idx].need_save=status
    this.setState({wnd})
  }

  delTWnd=(idx,q=true)=>{
    //let wnd=[...this.state.wnd]
    let wnd=this.state.wnd
    if(q&&wnd[idx]?.need_save){
      this.msg(localestr("Дані не збережено! \nЗакрити без збереження?"),localestr('Збереження даних'),[{caption:'OK',action:()=>this.delTWnd(idx,false)},{caption:localestr('Відмінити'),action:()=>{}}])
      return
    }
    wnd.splice(idx)
    wndTDataGl.splice(idx)
    this.setState({wnd})
  }

  setTWnd=(idx,data,need_save=undefined)=>{
    let wnd=[...this.state.wnd]
    if(wnd[idx].data) wnd[idx].data={...wnd[idx].data,...data}
    else wnd[idx].data={...data}
    if(need_save===true||need_save===false) wnd[idx].need_save=need_save
    this.setState({wnd})
  }

  newTWnd=(cont,capt)=>{
    let wnd=[...this.state.wnd]
    const idx=wnd.length
    const stl={width:'unset',height:'unset'}
    wnd.push({wnd:<WndForm key={idx} Text={cont} caption={capt} idx={idx} typeVal={''} stl_={stl} action={()=>this.delTWnd(idx)} />,data:null})
    wndTDataGl.push({})
    this.setState({wnd})
  }

  clsTWnd=()=>{
    let wnd=[...this.state.wnd]
    const idx=wnd.length
    if(idx) this.delTWnd(idx-1)
  }

  setGlData=(idx,data)=>{
    wndDataGl[idx]={...wndDataGl[idx],...data}
  }

  setGlDataT=(idx,data)=>{
    wndTDataGl[idx]={...wndTDataGl[idx],...data}
  }

  tblPos=(idx,arr,data=null)=>{ //для позиціонування скрола в таблиці
    if(data!==null&&arr&&arr[idx]) {arr[idx].pos=data;return data}
    else return arr[idx].pos||0
  }

  addTWnd=(capt,typeVal,callback,currVall=undefined,currParent=undefined,choice=true,stl,resizeable=true)=>{
    let wnd=[...this.state.wnd]
    const idx=wnd.length
    let cont=''
    let data=''
    const type=typeVal.substring(typeVal.length-4)
    if(currVall && type==='list') data={currentCol:currVall,currentFld:currParent,sorting:{dataId: 'name', sort: 'asc'}}
    else if(currVall && type==='edit') data={...currVall}
    else if(currVall) data={...currVall}
    const act={
      setWndData:(d,update)=>{this.setTWnd(idx,d,update)},
      getWndData:()=>{return (this.state.wnd[idx].data)},
      setGlData:(d)=>{this.setGlDataT(idx,d)},
      getGlData:()=>{return (wndTDataGl[idx])},
      isActive:()=>this.isActiveT(idx),
      tblPos:(d)=>this.tblPos(idx,wndTDataGl,d),
      tabNew:(wndType,caption,dataItem='')=>{this.addTWnd(caption,wndType,()=>{},dataItem)},
      setUpdate:(d)=>{this.setTUpdate(idx,d)},
      tabClose:(d)=>{this.delTWnd(idx,d)},
      tabChoice:(d)=>{callback(d)}
    }

    if(!this.state.urAdmin&&typeVal.substr(-4)==='edit'){
      let wndType1=typeVal.substr(0,typeVal.length-4)+'list'
      if(!this.state.rights[wndType1]) return null
    }
    if (typeVal==='catGoods_list') cont=<CatGoodsList actions={act} choice={choice}/>
    else if (typeVal==='catGoods_edit') cont=<CatGoodsEdit actions={act}/>
    else if (typeVal==='fldGoods_edit') cont=<FldGoodsEdit actions={act} choice={choice}/>
    else if (typeVal==='catMenuGrp_list') cont=<CatMenuGrpList actions={act} choice={choice}/>
    else if (typeVal==='catMenuGrp_edit') cont=<CatMenuGrpEdit actions={act}/>
    else if (typeVal==='fldMenuGrp_edit') cont=<FldMenuGrpEdit actions={act}/>
    else if (typeVal==='catUsers_list') cont=<CatUsersList actions={act} choice={choice}/>
    else if (typeVal==='catUsers_edit') cont=<CatUsersEdit actions={act}/>
    else if (typeVal==='catDevices_list') cont=<CatDevicesList actions={act} choice={choice}/>
    else if (typeVal==='catDevices3_edit') cont=<CatDevices3Edit actions={act} choice={choice}/>
    else if (typeVal==='catDevices4_edit') cont=<CatDevices4Edit actions={act} choice={choice}/>
    else if (typeVal==='catDevices4_viev') cont=<CatDevices4Viev actions={act} choice={choice}/>
    else if (typeVal==='catDevices5_edit') cont=<CatDevices5Edit actions={act} choice={choice}/>
    else if (typeVal==='catDevices5_viev') cont=<CatDevices5Viev actions={act} choice={choice}/>
    else if (typeVal==='catDepartments_list') cont=<CatDepartmentsList actions={act} choice={choice}/>
    else if (typeVal==='catDiscounts_list') cont=<CatDiscountsList actions={act} choice={choice}/>
    else if (typeVal==='catDiscounts_edit') cont=<CatDiscountsEdit actions={act}/>
    else if (typeVal==='fldDiscounts_edit') cont=<FldDiscountsEdit actions={act}/>
    else if (typeVal==='catHalls_list') cont=<CatHallsList actions={act} choice={choice}/>
    else if (typeVal==='catHalls_edit') cont=<CatHallsEdit actions={act}/>
    else if (typeVal==='catTables_list') cont=<CatTablesList actions={act} choice={choice}/>
    else if (typeVal==='catCounterparties_edit') cont=<CatCounterpartiesEdit actions={act}/>
    else if (typeVal==='catCounterparties_list') cont=<CatCounterpartiesList actions={act} choice={choice}/>
    else if (typeVal==='fldCounterparties_edit') cont=<FldCounterpartiesEdit actions={act}/>
    else if (typeVal==='catArticles_list') cont=<CatArticlesList actions={act} choice={choice}/>
    else if (typeVal==='catCashAccs_list') cont=<CatCashAccsList actions={act} choice={choice}/>
    else if (typeVal==='catReasons_list') cont=<CatReasonsList actions={act} choice={choice}/>
    else if (typeVal==='catReasons_edit') cont=<CatReasonsEdit actions={act}/>
    else if (typeVal==='catTexts_list') cont=<CatTextsList actions={act} choice={choice}/>
    else if (typeVal==='catCertificates_list') cont=<CatCertificatesList actions={act} choice={choice}/>
    else if (typeVal==='catCertificates_edit') cont=<CatCertificatesEdit actions={act}/>
    else if (typeVal==='catPositions_list') cont=<CatPositionsList actions={act} choice={choice}/>
    else if (typeVal==='catPositions_edit') cont=<CatPositionsEdit actions={act}/>
    else if (typeVal==='catEmployees_list') cont=<CatEmployeesList actions={act} choice={choice}/>
    else if (typeVal==='catEmployees_edit') cont=<CatEmployeesEdit actions={act}/>
    else if (typeVal==='catStreets_list') cont=<CatStreetsList actions={act} choice={choice}/>
    else if (typeVal==='catCities_list') cont=<CatCitiesList actions={act} choice={choice}/>
    else if (typeVal==='catAreas_list') cont=<CatAreasList actions={act} choice={choice}/>

    else if (typeVal==='docOrder_list') cont=<DocOrderList actions={act} choice={choice}/>
    else if (typeVal==='docOrder_edit') cont=<DocOrderEdit actions={act}/>
    else if (typeVal==='docSupply_list') cont=<DocSupplyList actions={act} choice={choice}/>
    else if (typeVal==='docSupply_edit') cont=<DocSupplyEdit actions={act}/>
    else if (typeVal==='docReject_list') cont=<DocRejectList actions={act} choice={choice}/>
    else if (typeVal==='docReject_edit') cont=<DocRejectEdit actions={act}/>
    else if (typeVal==='docTransfer_list') cont=<DocTransferList actions={act} choice={choice}/>
    else if (typeVal==='docTransfer_edit') cont=<DocTransferEdit actions={act}/>
    else if (typeVal==='docExpence_list') cont=<DocExpenceList actions={act} choice={choice}/>
    else if (typeVal==='docExpence_edit') cont=<DocExpenceEdit actions={act}/>
    else if (typeVal==='docSurplus_list') cont=<DocSurplusList actions={act} choice={choice}/>
    else if (typeVal==='docSurplus_edit') cont=<DocSurplusEdit actions={act}/>
    else if (typeVal==='docCalculation_list') cont=<DocCalculationList actions={act} choice={choice}/>
    else if (typeVal==='docCalculation_edit') cont=<DocCalculationEdit actions={act}/>
    else if (typeVal==='docProduction_list') cont=<DocProductionList actions={act} choice={choice}/>
    else if (typeVal==='docProduction_edit') cont=<DocProductionEdit actions={act}/>
    else if (typeVal==='docRevision_list') cont=<DocRevisionList actions={act} choice={choice}/>
    else if (typeVal==='docRevision_edit') cont=<DocRevisionEdit actions={act}/>
    else if (typeVal==='docStatement_list') cont=<DocStatementList actions={act} choice={choice}/>
    else if (typeVal==='docStatement_edit') cont=<DocStatementEdit actions={act}/>
    else if (typeVal==='docCashadjust_list') cont=<DocCashadjustList actions={act} choice={choice}/>
    else if (typeVal==='docCashadjust_edit') cont=<DocCashadjustEdit actions={act}/>
    else if (typeVal==='docDebtadjust_list') cont=<DocDebtadjustList actions={act} choice={choice}/>
    else if (typeVal==='docDebtadjust_edit') cont=<DocDebtadjustEdit actions={act}/>
    else if (typeVal==='docBonusadjust_list') cont=<DocBonusadjustList actions={act} choice={choice}/>
    else if (typeVal==='docBonusadjust_edit') cont=<DocBonusadjustEdit actions={act}/>
    else if (typeVal==='docRefillCert_list') cont=<DocRefillCertList actions={act} choice={choice}/>
    else if (typeVal==='docRefillCert_edit') cont=<DocRefillCertEdit actions={act}/>
    else if (typeVal==='docNullifyCert_list') cont=<DocNullifyCertList actions={act} choice={choice}/>
    else if (typeVal==='docNullifyCert_edit') cont=<DocNullifyCertEdit actions={act}/>
    else if (typeVal==='docSalary_list') cont=<DocSalaryList actions={act} choice={choice}/>
    else if (typeVal==='docSalary_edit') cont=<DocSalaryEdit actions={act}/>
    else if (typeVal==='docPayment_list') cont=<DocPaymentList actions={act} choice={choice}/>
    else if (typeVal==='docPayment_edit') cont=<DocPaymentEdit actions={act}/>
    else if (typeVal==='docConversion_list') cont=<DocConversionList actions={act} choice={choice}/>
    else if (typeVal==='docConversion_edit') cont=<DocConversionEdit actions={act}/>

    else if (typeVal==='irgStopList') cont=<IrgStopList actions={act}/>
    else if (typeVal==='irgTimekeeping_list') cont=<IrgTimekeepingList actions={act}/>

    else if (typeVal==='serv_check') cont=<ServCheck actions={act}/>
    else if (typeVal==='serv_grp_edit') cont=<ServGrpEdit actions={act}/>
    else if (typeVal==='serv_grp_doc') cont=<ServGrpDoc actions={act}/>
    else if (typeVal==='repSupplies') cont=<RepSupplies actions={act}/>
    else if (typeVal==='repCalcs') cont=<RepCalcs actions={act}/>
    else if (typeVal==='repProduction') cont=<RepProduction actions={act}/>
    else if (typeVal==='repStock') cont=<RepStock actions={act}/>
    else if (typeVal==='repSales') cont=<RepSales actions={act}/>
    else if (typeVal==='repReturn') cont=<RepReturn actions={act}/>
    else if (typeVal==='repStats') cont=<RepStats actions={act}/>
    else if (typeVal==='servQRDesign') cont=<ServQRDesign actions={act}/>

    else if (typeVal==='aiSupplyFill') cont=<AISupplyFill actions={act}/>
    
    wnd.push({wnd:<WndForm key={idx} Text={cont} caption={capt} idx={idx} action={()=>this.delTWnd(idx)} typeVal={typeVal} stl_={stl} resizeable={resizeable}/>,data})
    wndTDataGl.push({})
    this.setState({wnd})
  }

  getWnd=(wndType,idx)=>{
    const act={
      setWndData:(data,update)=>{this.setWndData(idx,data,update)},
      //getWndData:()=>{return (this.state.wnd[idx].data)},
      isActive:()=>this.isActive(idx),
      getWndData:()=>{return (this.state.windows[idx]?.data)},
      setGlData:(d)=>{this.setGlData(idx,d)},
      getGlData:()=>{return (wndDataGl[idx])},
      tblPos:(d)=>this.tblPos(idx,wndDataGl,d),
      tabNew:this.tabNew,
      setUpdate:(d)=>{this.setUpdate(idx,d)},
      tabClose:(d)=>{this.tabClose(idx,this.state.activeWindow,d)}
    }
    if(!this.state.urAdmin&&wndType.substr(-4)==='edit'){
      let wndType1=wndType.substr(0,wndType.length-4)+'list'
      if(!this.state.rights[wndType1]) return null
    }

    if (wndType==='catGoods_list') return (<CatGoodsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catGoods_edit') return (<CatGoodsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='fldGoods_edit') return (<FldGoodsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catMenuGrp_list') return (<CatMenuGrpList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catMenuGrp_edit') return (<CatMenuGrpEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='fldMenuGrp_edit') return (<FldMenuGrpEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catUsers_list') return (<CatUsersList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catUsers_edit') return (<CatUsersEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDevices_list') return (<CatDevicesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDevices3_edit') return (<CatDevices3Edit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDevices4_edit') return (<CatDevices4Edit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDevices5_edit') return (<CatDevices5Edit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDepartments_list') return (<CatDepartmentsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDiscounts_list') return (<CatDiscountsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catDiscounts_edit') return (<CatDiscountsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='fldDiscounts_edit') return (<FldDiscountsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catHalls_list') return (<CatHallsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catHalls_edit') return (<CatHallsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catTables_list') return (<CatTablesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCounterparties_edit') return (<CatCounterpartiesEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCounterparties_list') return (<CatCounterpartiesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='fldCounterparties_edit') return (<FldCounterpartiesEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catArticles_list') return (<CatArticlesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCashAccs_list') return (<CatCashAccsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catReasons_list') return (<CatReasonsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catReasons_edit') return (<CatReasonsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catTexts_list') return (<CatTextsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCertificates_list') return (<CatCertificatesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCertificates_edit') return (<CatCertificatesEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catPositions_list') return (<CatPositionsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catPositions_edit') return (<CatPositionsEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catEmployees_list') return (<CatEmployeesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catEmployees_edit') return (<CatEmployeesEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catStreets_list') return (<CatStreetsList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catCities_list') return (<CatCitiesList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='catAreas_list') return (<CatAreasList data={{wndData:this.state.windows[idx].data}} actions={act}/>)

    if (wndType==='docOrder_list') return (<DocOrderList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docOrder_edit') return (<DocOrderEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSupply_list') return (<DocSupplyList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSupply_edit') return (<DocSupplyEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docReject_list') return (<DocRejectList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docReject_edit') return (<DocRejectEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docTransfer_list') return (<DocTransferList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docTransfer_edit') return (<DocTransferEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docExpence_list') return (<DocExpenceList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docExpence_edit') return (<DocExpenceEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSurplus_list') return (<DocSurplusList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSurplus_edit') return (<DocSurplusEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docCalculation_list') return (<DocCalculationList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docCalculation_edit') return (<DocCalculationEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docProduction_list') return (<DocProductionList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docProduction_edit') return (<DocProductionEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docRevision_list') return (<DocRevisionList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docRevision_edit') return (<DocRevisionEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docStatement_list') return (<DocStatementList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docStatement_edit') return (<DocStatementEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docCashadjust_list') return (<DocCashadjustList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docCashadjust_edit') return (<DocCashadjustEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docDebtadjust_list') return (<DocDebtadjustList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docDebtadjust_edit') return (<DocDebtadjustEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docBonusadjust_list') return (<DocBonusadjustList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docBonusadjust_edit') return (<DocBonusadjustEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docRefillCert_list') return (<DocRefillCertList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docRefillCert_edit') return (<DocRefillCertEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docNullifyCert_list') return (<DocNullifyCertList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docNullifyCert_edit') return (<DocNullifyCertEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSalary_list') return (<DocSalaryList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docSalary_edit') return (<DocSalaryEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docPayment_list') return (<DocPaymentList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docPayment_edit') return (<DocPaymentEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docConversion_list') return (<DocConversionList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='docConversion_edit') return (<DocConversionEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)

    if (wndType==='irgStopList') return (<IrgStopList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='irgTimekeeping_list') return (<IrgTimekeepingList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    
    if (wndType==='docPrint') return (<DocPrint data={{wndData:this.state.windows[idx].data}} actions={act}/>)

    if (wndType==='repSupplies') return (<RepSupplies data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repLiability') return (<RepLiability data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repDebt') return (<RepDebt data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repCalcs') return (<RepCalcs data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repProduction') return (<RepProduction data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repStock') return (<RepStock data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repSales') return (<RepSales data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repReturn') return (<RepReturn data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repStats') return (<RepStats data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repForm496') return (<RepForm496 data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repCashflow') return (<RepCashflow data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repPnL') return (<RepPnL data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repDelivery') return (<RepDelivery data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repConversion') return (<RepConversion data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repObjHistory') return (<RepObjHistory data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repObjEntries') return (<RepObjEntries data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='repSysLog') return (<RepSysLog data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType === 'repSysBASE') return ( <RepSysBASE wndData={this.state.windows[idx].data} actions={act} buttons={[{ caption: localestr('Вивантажити') }]} setModal={this.setModal}/>);

    if (wndType==='sysConst_list') return (<SysConstList data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    
    if (wndType==='serv_check') return (<ServCheck data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='serv_grp_edit') return (<ServGrpEdit data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='serv_grp_doc') return (<ServGrpDoc data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    if (wndType==='servQRDesign') return (<ServQRDesign data={{wndData:this.state.windows[idx].data}} actions={act}/>)
    return <div>{wndType}</div>
  }

  new_window=(data)=>{
    const type_wnd=allTypes.find(it=>it.value===data.type)
    if(data.type.substr(0,3)==='cat'||data.type.substr(0,3)==='fld'){
      const d=this.getData(data.type,true,null,(d)=>{this.new_window({...data,...d})})
      //if (!d) setTimeout(()=>{this.new_window(data)},10+Math.floor(Math.random() * 200))
      if (!d) return
      else {
        const el=d.find(it=>it.id===data.id)
        this.tabNew(type_wnd.edit,type_wnd.caption_edit+' '+toText(el['name']),{...el})
      }
    } else if(data.type.substr(0,3)==='doc'){
      if(!data.status) this.getData(data.type,true,data.id,(d)=>{this.new_window({...data,...d})})
      else this.tabNew(type_wnd.edit,type_wnd.caption_edit+' №'+toText(data.data['id']),{...data.data,table:data.table,update:()=>{}})

    }
    //this.tabNew(data.type+'_list',localestr('Меню'),{currentCol:{...data}})
  }

  setLoginData=(data)=>{
    const status=data.status
    let loginData={}
    if (status==='UsrChoise') {
      loginData=data
      this.setState({status,loginData})
    }
  }

  setLogin=(data)=>{
    const status=data.status
    let loginData={}
    if (status==='UsrChoise') {
      loginData=data
      this.setState({status,loginData,windows:[]})
    } else if (status==='OffLine'){
      this.msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
    } else if (status==='OK'){
      const user=data.user
      const urAdmin=data.urAdmin
      const rights=data.rights
      const last_rev=data.last_rev
      let usersettings=localStorage.getItem(user)
      if (usersettings) usersettings=JSON.parse(usersettings)
      else usersettings=undefined
      if(usersettings) this.setSettings(usersettings)
      //this.setState({status,user,usersettings,user_id:data.userId})
      this.setState({status,user,user_id:data.userId,urAdmin,rights,last_rev})
      const loc_user=localStorage.getItem('user') || ''
      if (loc_user!==user) localStorage.setItem('user', user)
      this.getData('sysConst')

    } else if (status==='error'){
      this.setState({status})
      this.msg(localestr(data.msg),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
    }
  }
  
  getFolders=(data)=>{
    for(let i=0;i<data.length;i++){
      if(data[i].parent&&data[i].parent.id){
        const parent=data.find(el=>el.id===data[i].parent.id)
        if(parent) data[i].parent=parent
      }
    }
    return data
  }

  OpenTabObject=(dataType,id,newData)=>{
    if(newData){
      const status=newData.status
      if (status==='OffLine') {this.msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
      if (status==='error') {this.msg(newData.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
      if(dataType.substring(0, 3)==='doc') this.tabNew(dataType+'_edit',typeToText(dataType)+' №'+toText(newData.data['id']),{...newData.data,table:newData.table})
      else if(dataType==='catMenu') {const curr=newData.data.find(el=>el.id===id);this.tabNew('catMenu_list',typeToText(dataType),{currentCol:curr,currentFld:curr.parent},true)}
      else if(dataType==='catGoods') {const curr=newData.data.find(el=>el.id===id);this.tabNew('catGoods_list',typeToText(dataType),{currentCol:curr,currentFld:curr.parent||null},true)}
      else if(dataType==='catCounterparties') {const curr=newData.data.find(el=>el.id===id);this.tabNew('catCounterparties_list',typeToText(dataType),{currentCol:curr,currentFld:curr.parent},true)}
      else if(dataType.substring(0,3)==='cat') {const curr=newData.data.find(el=>el.id===id);this.tabNew(dataType+'_list',typeToText(dataType),{currentCol:curr},true)}
    } else {
      if(dataType.substring(0,3)==='doc') load('action='+dataType+'&data='+id,(d)=>{this.OpenTabObject(dataType,id,d)})
      else {
        const data=this.state.data[dataType]
        if (!data) load('action='+dataType,(d)=>{this.setData(d);this.OpenTabObject(dataType,id,d)})
        else this.OpenTabObject(dataType,id,{status:'OnLine',data})
      }
    }
  }

  setData=(newData,callback)=>{
    const status=newData.status
    if (status==='error') {this.msg(newData.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);this.setState({status:'OnLine'});return}
    if(!newData.data) {this.setState({status});return}
    let data=this.state.data
    if(newData.key.substring(0,3)==='fld') data[newData.key]=this.getFolders(newData.data)
    else if(newData.key.substring(0,3)==='doc') {
      if(callback) setTimeout(()=>callback(newData),200)
      this.setState({status:'OnLine'})
      return
    }
    else data[newData.key]=newData.data
    if(newData.folders) data['fld'+newData.key.substring(3)]=this.getFolders(newData.folders)
    this.setState({data,status:'OnLine'})
    if(callback) setTimeout(()=>callback({}),200)
  }

  addData=(newData)=>{
    if(!newData) return
    const status=newData.status
    if (status==='error') {this.msg(newData.msg,localestr('Помилка'),[{caption:'OK',action:()=>{this.setState({status:'OnLine'})}}]);this.setState({status:'OnLine'});return}
    //if (status==='OffLine') {this.setState({status:'OffLine'});return}
    let data=this.state.data
    if (data[newData.key]===undefined) data[newData.key]=newData.data
    else {
      let upddata=data[newData.key]
      const pid=newData.data[0].id
      upddata=upddata.filter(el=>el.id!==pid)
      data[newData.key]=upddata.concat(newData.data)
    }
    this.setState({data,status})
  }

  getData=(dataType,loading=true,pid=null,callback)=>{
    if(busy){
      //busy=false
      setTimeout(()=>{this.getData(dataType,loading,pid,callback)},100+Math.floor(Math.random() * 100))
      return undefined
    }
    if (dataType.substring(0, 3)==='irg'&&dataType!=='irgStopList'){
      const arrData=this.state.data[dataType]
      if (arrData===undefined){
        if (this.state.status==='loading') {console.log('aborted');return undefined}
        if(loading) this.setState({status:'loading'})
        setTimeout(()=>{load('action='+dataType+"&data="+JSON.stringify({id:pid}),(data)=>{this.addData(data)})},10+Math.floor(Math.random() * 200))
        return undefined
      }
      else {
        const data=arrData.filter(el=>el.id===pid)
        if (data.length===0) {
          if (this.state.status==='loading') {console.log('aborted');return undefined}
          if(loading) this.setState({status:'loading'})
          setTimeout(()=>{load('action='+dataType+"&data="+JSON.stringify({id:pid}),(data)=>{this.addData(data)})},10+Math.floor(Math.random() * 200))
          return undefined
        }
        return data
      }
    }
    //if (this.state.status==='loading') setTimeout(()=>this.setState({status:'onLine'}),2000)
    else if(dataType.substring(0, 3)==='doc'){
      if (this.state.status==='loading') {setTimeout(()=>{this.getData(dataType,loading,pid,callback)},300+Math.floor(Math.random() * 200));return undefined}
      if(loading) this.setState({status:'loading'})
      setTimeout(()=>{if (typeof this.state.data[dataType] === 'undefined') load('action='+dataType+'&data='+pid,(data)=>{this.setData(data,callback)})},10+Math.floor(Math.random() * 200))
    }
    else{
      const data=this.state.data[dataType]
      if (typeof this.state.data[dataType] === 'undefined') {
        if (this.state.status==='loading') {setTimeout(()=>{this.getData(dataType,loading,pid,callback)},300+Math.floor(Math.random() * 200));return undefined}
        setTimeout(()=>{if (typeof this.state.data[dataType] === 'undefined'){
          load('action='+dataType,(data)=>{this.setData(data,callback)})
        }},100)
        if(loading) this.setState({status:'loading'})
        busy=true
        setTimeout(()=>busy=false,100)
        //load('action='+dataType,(data)=>{this.setData(data)})
      }
      return data
    }
  }

  saveData=(newData,action)=>{
    const act=newData.status
    if (act==='error') {this.msg(newData.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);this.setState({status:'OnLine'});return}
    const dataType=newData.key
    const data=newData.data
    let dataJS=''
    if(data) dataJS=encodeURIComponent(JSON.stringify(data))
    //dataJS = dataJS.replace(new RegExp('\'','g'),'\'\'')

    let dataOper=dataType
    if (dataOper.substring(0, 3)==='cat'||dataOper.substring(0, 3)==='Cat'||dataOper.substring(0, 3)==='doc'||dataOper.substring(0, 3)==='sys') dataOper=dataOper.substring(3)
    if (act.substring(3)!=='Ok') this.setState({status:'loading'})
    //якщо статут Адд добавляємо на сервері
    //if (act==='add') load("action=add"+dataOper+"&data="+dataJS,(d)=>{action(d);this.saveData(d)})
    if (act==='add') load("action=add"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    //якщо статут Мод обновляємо на сервері
    else if (act==='mod') load("action=mod"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    //якщо статут Рем ставимо позначку на видалення на сервері
    else if (act==='rem') load("action=rem"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    //регістри!!!
    else if (act==='set') load("action=set"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    else if (act==='del') load("action=del"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    else if (act==='rgo') load("action=rgo"+dataOper+"&data="+dataJS,d=>this.saveData(d,action))
    //видалення!!!
    else if (act==='clr') load("action=clr"+dataOper,d=>this.saveData(d,action))

    //якщо статут АддОк добавляємо в дані
    //якщо статут МодОк обновляємо дані по Ід
    else if (act==='addOk') {
      const d_Data=this.state.data[dataType].filter(item=>data.id!==item.id).concat(data)
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='modOk' && dataType==='sysConst') {
      const d_Data={...this.state.data[dataType]}
      for (let key in data) d_Data[key]=data[key]
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='modOk') {
      const d_Data=this.state.data[dataType].map(item=>item.id===data.id?{...item,...data}:item)
      //const d_Data=this.state.data[dataType].filter(item=>data[0].id!==item.id).concat(data)
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      this.setState({data:n_Data,status:'OnLine'})
    }
    //якщо статут РемОк обновляємо дані по Ід
    else if (act==='remOk') {
      //const d_Data=this.state.data[dataType].map(item=>item.id===data.id?{...item,marked:data.marked}:item)
      const d_Data=this.state.data[dataType].map(item=>item.id===data.id?{...item,...data}:item)
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='delIrg') {
      //const d_Data=this.state.data[dataType].map(item=>item.id===data.id?{...item,marked:data.marked}:item)
      const d_Data=(this.state.data[dataType]||[]).filter(item=>item.id!==data.id)
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      this.setState({data:n_Data,status:'OnLine'})
      this.setState({status:'OnLine'})
    }
    else if (act==='setOk') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history||[]
      if(data.updkey==='sum_out') d_Data=catData[idx].price_history_out||[]
      if (data.olddate){
        d_Data=d_Data.map(item=>{
          if(item.id===data.id&&item.date===data.olddate+'T00:00:00Z'&&data.value) return {id:data.id,date:data.date+'T00:00:00Z',value:data.value}
          if(item.id===data.id&&item.date===data.olddate+'T00:00:00Z') return {id:data.id,date:data.date+'T00:00:00Z',value:item.value}
          return {...item}
        })
      }
      else d_Data=d_Data.concat({id:data.id,date:data.date+'T00:00:00Z',value:data.value})
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      if(data.updkey==='sum_out') catData[idx].price_history_out=d_Data
      else catData[idx].price_history=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='se2Ok') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history_out||[]
      if (data.olddate){
        d_Data=d_Data.map(item=>{
          if(item.id===data.id&&item.date===data.olddate+'T00:00:00Z'&&data.value) return {id:data.id,date:data.date+'T00:00:00Z',value:data.value}
          if(item.id===data.id&&item.date===data.olddate+'T00:00:00Z') return {id:data.id,date:data.date+'T00:00:00Z',value:item.value}
          return {...item}
        })
      }
      else d_Data=d_Data.concat({id:data.id,date:data.date+'T00:00:00Z',value:data.value})
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      catData[idx].price_history_out=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='delOk') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history
      if (data.olddate){
        d_Data=d_Data.filter(item=>item.id===data.id&&item.date!==data.olddate+'T00:00:00Z')
      }
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      catData[idx].price_history=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='de2Ok') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history_out
      if (data.olddate){
        d_Data=d_Data.filter(item=>item.id===data.id&&item.date!==data.olddate+'T00:00:00Z')
      }
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      catData[idx].price_history_out=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='rgoOk') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history||[]
      const grp=data.grp
      for (let idx=0;idx<grp.length;idx++){
        if(grp[idx].act==='del'){
          if (grp[idx].olddate){
            d_Data=d_Data.filter(item=>item.id===data.id&&item.date!==grp[idx].olddate+'T00:00:00Z')
          }
        }
        else{
          if (grp[idx].olddate){
            d_Data=d_Data.map(item=>{
              if(item.id===data.id&&item.date===grp[idx].olddate+'T00:00:00Z'&&grp[idx].value) return {id:data.id,date:grp[idx].date+'T00:00:00Z',value:grp[idx].value}
              if(item.id===data.id&&item.date===grp[idx].olddate+'T00:00:00Z') return {id:data.id,date:grp[idx].date+'T00:00:00Z',value:item.value}
              return {...item}
            })
          }
          else d_Data=d_Data.concat({id:data.id,date:grp[idx].date+'T00:00:00Z',value:grp[idx].value})
        }
      }
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      catData[idx].price_history=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='rg2Ok') {
      let n_Data=this.state.data
      const catData=[...n_Data[data.updcat]]
      const idx=catData.findIndex(el=>el.id===data.id)
      if(idx===-1) {this.setState({status:'OnLine'});return}
      let d_Data=catData[idx].price_history_out||[]
      const grp=data.grp
      for (let idx=0;idx<grp.length;idx++){
        if(grp[idx].act==='del'){
          if (grp[idx].olddate){
            d_Data=d_Data.filter(item=>item.id===data.id&&item.date!==grp[idx].olddate+'T00:00:00Z')
          }
        }
        else{
          if (grp[idx].olddate){
            d_Data=d_Data.map(item=>{
              if(item.id===data.id&&item.date===grp[idx].olddate+'T00:00:00Z'&&grp[idx].value) return {id:data.id,date:grp[idx].date+'T00:00:00Z',value:grp[idx].value}
              if(item.id===data.id&&item.date===grp[idx].olddate+'T00:00:00Z') return {id:data.id,date:grp[idx].date+'T00:00:00Z',value:item.value}
              return {...item}
            })
          }
          else d_Data=d_Data.concat({id:data.id,date:grp[idx].date+'T00:00:00Z',value:grp[idx].value})
        }
      }
      d_Data.sort((a,b)=>{if(a.id>b.id) return 1; if(a.id<b.id) return -1; if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
      catData[idx].price_history_out=d_Data
      //обновити пер.реквізит
      const currDate=(new Date()).toISOString().split('.')[0]+'Z'
      let currVal=''
      d_Data.forEach(el=>{if(!currVal&&el.date<=currDate) currVal=el.value})
      catData[idx][data.updkey]=currVal
      n_Data[data.updcat]=catData
      this.setState({data:n_Data,status:'OnLine'})
    }
    else if (act==='clrOk') {
      let d_Data=[...this.state.data[dataType]]
      let cont_del=[]
      let cont_no=[]
      data.forEach(el=>{
        if(el.used_in){
          const in_cont=el.used_in.map((it,id)=>{return <div className='link' key={'i'+id} onClick={()=>this.new_window(it)}>{itemToText(it)}</div>})
          cont_no.push(<div style={{padding:'0 0 0 10px'}} key={'n'+cont_no.length}>{el.name} {localestr('використовується в')}{in_cont}</div>)
        }else{
          const idx=d_Data.findIndex(e=>e.id===el.id)
          if(idx!==-1) d_Data.splice(idx,1)
            cont_del.push(<div style={{padding:'0 0 0 10px'}} key={'d'+cont_del.length}>{el.name}</div>)
        }
      })
      let n_Data=this.state.data
      n_Data[dataType]=d_Data
      if(dataType==='catGoods'||dataType==='catMenu'){
        const data_f=newData.folders
        let df_Data=[...this.state.data['fld'+dataType.substring(3)]]
        data_f.forEach(el=>{
          if(el.used_in){
            const in_cont=el.used_in.map((it,id)=>{return <div className='link' key={'i'+id} onClick={()=>this.new_window(it)}>{itemToText(it)}</div>})
            cont_no.push(<div style={{padding:'0 0 0 10px'}} key={'n'+cont_no.length}>{el.name} {localestr('використовується в')}{in_cont}</div>)
          }else{
            const idx=df_Data.findIndex(e=>e.id===el.id)
            if(idx!==-1) df_Data.splice(idx,1)
              cont_del.push(<div style={{padding:'0 0 0 10px'}} key={'d'+cont_del.length}>{el.name}</div>)
          }
        })
        n_Data['fld'+dataType.substring(3)]=df_Data
      }
      if(dataType==='catHalls'){
        const data_f=newData.tables
        let df_Data=[]
        if(n_Data['catTables']) df_Data=[...n_Data['catTables']]
        data_f.forEach(el=>{
          if(el.used_in){
            const in_cont=el.used_in.map((it,id)=>{return <div className='link' key={'i'+id} onClick={()=>this.new_window(it)}>{itemToText(it)}</div>})
            cont_no.push(<div style={{padding:'0 0 0 10px'}} key={'n'+cont_no.length}>{el.name} {localestr('використовується в')}{in_cont}</div>)
          }else{
            const idx=df_Data.findIndex(e=>e.id===el.id)
            if(idx!==-1) df_Data.splice(idx,1)
              cont_del.push(<div style={{padding:'0 0 0 10px'}} key={'d'+cont_del.length}>{el.name}</div>)
          }
        })
        if(n_Data['catTables']) n_Data['catTables']=df_Data
      }
      
      this.setState({data:n_Data,status:'OnLine'})
      let cont=null
      if(cont_del.length>0&&cont_no.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Видалено')+' '+cont_del.length}</div><div>{cont_del}</div><div style={{fontWeight:'bold'}}>{localestr('Не видалено')+' '+cont_no.length}</div><div>{cont_no}</div></div>
      else if(cont_no.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Не видалено')+' '+cont_no.length}</div><div>{cont_no}</div></div>
      else if(cont_del.length>0) cont=<div><div style={{fontWeight:'bold'}}>{localestr('Видалено')+' '+cont_del.length}</div><ul>{cont_del}</ul></div>
      this.msg(cont,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
    }
    if (act.substring(3)==='Ok') action(newData)
  }

  updateData=(dataType,data)=>{
    if(data){
      const status=data.status
      if (status==='error') {this.msg(data.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);this.setState({status:'OnLine'});return}
      if(!data.data) {this.setState({status});return}
      let d=this.state.data
      if(data.key.substring(0,3)==='fld') data[data.key]=this.getFolders(data.data)
      else if(data.key.substring(0,3)==='doc') {
        this.setState({status:'OnLine'})
        return
      }
      else d[data.key]=data.data
      if(data.folders) d['fld'+data.key.substring(3)]=this.getFolders(data.folders)
      this.setState({data:d,status:'OnLine'})
    } else {
      if (this.state.status==='loading') {setTimeout(()=>{this.updateData(dataType)},10+Math.floor(Math.random() * 200));return}
      setTimeout(()=>{load('action='+dataType,(d)=>{this.updateData(dataType,d)})},10+Math.floor(Math.random() * 200))
    }
  }

  loadfrm=(formData,action)=>{
    this.setState({status:'loading'})
    loadfrm(formData,action)
  }

  loaddata=(formData,data,action,on_err_next=false)=>{
    if(formData){
      this.setState({status:'loading'})
      loaddat(formData,d=>this.loaddata(undefined,d,action,on_err_next))
    } else if(data.status==='error') {
      this.setState({status:'OnLine'})
      if(on_err_next) action(data)
      else if(this.state.modal) this.msg2(data.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
      else this.msg(data.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
    } else {
      if(data.msg) {
        if(this.state.modal) this.msg2(data.msg,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
        else this.msg(data.msg,localestr('Інформація'),[{caption:'OK',action:()=>{}}])
      }
      if(data.print) { //Друк
        data.print.forEach(d => {
          if(d.type==='svg'){
              const items=d.data.map((el,idx)=>{
                  if(el.type==='text') return <text key={idx} style={el.style} x={el.x} y={el.y}>{el.text}</text>
                  else if(el.type==='line') return <line key={idx} x1={el.x1} y1={el.y1} x2={el.x2} y2={el.y2} stroke='black' strokeWidth='0.2'/>
                  else if(el.type==='rect') return <rect key={idx} x={el.x} y={el.y} width={el.width} height={el.height} />
                  else if(el.type==='img') return <image key={idx} x={el.x} y={el.y} width={el.width} height={el.height} href={el.src} />
                  return null
              })
              const cont=<svg xmlns="http://www.w3.org/2000/svg" viewBox={'0 0 '+d.width+' '+d.height}  width={d.width+'mm'} height={d.height+'mm'}>{items}</svg>
              if(this.state.modal) this.msg2(cont,localestr('Друк'))
              else this.msg(cont,localestr('Друк'))
              if(d.print_cmd) setTimeout(() => window.print(), 200)
          }
        })
      }
      this.setState({status:'OnLine'})
      action(data)
    }
  }

  setWndData=(idx,data,need_save=undefined)=>{
    if(need_save===true||need_save===false){
      const windows=this.state.windows.map((item,index)=>{if (index===idx) return {caption:item.caption,wndType:item.wndType,data,need_save}; else return (item)})
      this.setState({windows})
    } else {
      const windows=this.state.windows.map((item,index)=>{if (index===idx) return {caption:item.caption,wndType:item.wndType,data,need_save:item.need_save}; else return (item)})
      this.setState({windows})
    }
  }
  
  getWndData=(idx)=>{
    return this.state.windows[idx].data
  }

  getSettings=()=>{
    return allSettings
  }

  setSettings=(data)=>{
    allSettings={...allSettings, ...data}
    //this.setState({usersettings})
    if (this.state.user && allSettings) localStorage.setItem(this.state.user,JSON.stringify(allSettings))
  }

  getPosition=id=>{
    return positions[id]||0
  }
  
  setPosition=(id,pos)=>{
    positions[id]=parseInt(pos)||0
  }

  beforeClose=(event)=>{

    if(this.state.windows&&this.state.windows.find(el=>el.need_save)){
      event.preventDefault()
      event.returnValue = ''
    }
  }
  componentDidMount(){
    const user=localStorage.getItem('user') || ''
    this.setState({user})
    window.addEventListener('beforeunload', (event)=>{this.beforeClose(event)})
    load("action=init",this.setLogin)
    //window.addEventListener('keydown', this.handleKeyPres)
  }

  componentWillUnmount() {
    //window.removeEventListener('keydown', this.handleKeyPres);
    //if (this.state.user && this.state.usersettings) localStorage.setItem(this.state.user,JSON.stringify(this.state.usersettings))
  }

  render(){
    const {status, user,modal,modal2,loginData,menu,hidenmenu,activeWindow,windows,wnd}=this.state
    let wndEl=''
    if(wnd.length>0) wndEl=<div className='modal'>{wnd.map(el=>el.wnd)}</div>
    if(status==='error') return(
      modal
    )
    return (

      !status ? (
      <Loader />
      ):(
        status==='OrgChoise' ? (
        <AuthForm status={status} inUser={user} loginData={loginData} setLogin={this.setLogin} />
        ):(
        status==='UsrChoise' ?(
          <AuthForm status={status} inUser={user} loginData={loginData} setLogin={this.setLogin} />
          ):(
            <dataContext.Provider value={{status,data:this.state.data,user:{name:this.state.user,id:this.state.user_id,urAdmin:this.state.urAdmin,rights:this.state.rights},last_rev:this.state.last_rev, 
              getData:this.getData,saveData:this.saveData,updateData:this.updateData,
              loadfrm:this.loadfrm,loaddata:this.loaddata,
              setSettings:this.setSettings, getSettings:this.getSettings, getPosition:this.getPosition, setPosition:this.setPosition,
              msg:this.msg,msg2:this.msg2,close_msg:this.close_msg,msg_arr:this.msg_arr,
              inputRange:this.inputRange,inputNumber:this.inputNumber,inputWeight:this.inputWeight,inputWeight2:this.inputWeight2,inputLongText:this.inputLongText,
              inputExcise:this.inputExcise,inputCols:this.inputCols,inputText:this.inputText,
              addTWnd:this.addTWnd,newTWnd:this.newTWnd,clsTWnd:this.clsTWnd,OpenTabObject:this.OpenTabObject,new_window:this.new_window,setLoginData:this.setLoginData,ws}}>
            <>
            {/*<Header status={status} User={user} actions={{setLogin:this.setLogin}}/>*/}<div>
            <MenuBar MenuData={menu} tabNew={this.tabNew} hiden={hidenmenu} showHideMenu={this.showHideMenu} consts={this.state.data['sysConst']||[]} urAdmin={this.state.urAdmin} rights={this.state.rights} />
            <div className='panel' style={{width:'100%'}}><TabPanel ActiveTab={activeWindow} Tabs={windows} TabClick={this.tabClick} TabClose={this.tabClose} status={status} User={user} actions={{setLogin:this.setLogin}}/>
            <div className='print' style={{position:'relative',width:'calc(100% - 2px)',height:'100%',overflow:'auto'}}>{windows.length===0?'':!windows[activeWindow]?'':this.getWnd(windows[activeWindow].wndType,activeWindow)}</div>
            </div></div>
            {wndEl}
            {modal}
            {modal2}
            {status==='loading' ? ( <Loader /> ):( '' )}
            </>
            </dataContext.Provider>
          )
        )
      )
    )

  }
}

export default App;
